<template>
  <div class="shadow-lg bg-white mr-1 rounded-b-lg rounded-t">
    <div class="px-6 py-4">
      <div class="uppercase tracking-wide text-c2 mb-4">
        模試作成
      </div>
      <Link
        v-for="subject in subjects"
        :key="subject.id"
        :href="route('questions', { subject: subject.id })">
        <div
          class="flex cursor-pointer border px-4 py-2 text-lg text-grey-darkest hover:bg-indigo-500 hover:text-white"
          :class="activeClass(subject)">
          <svg
            class="w-6 h-6"
            fill="none"
            :stroke="subject.id === selectedSubject.id ? 'white': 'gray'"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253">
            </path>
          </svg>
          <div class="pl-2 pt-1 text-sm">
            {{ subject.title }}
          </div>
        </div>
      </Link>
    </div>
  </div>
</template>

<script setup>
import { Link } from '@inertiajs/inertia-vue3'

const props = defineProps({
  subjects: {
    type: Array,
    required: true,
    default: () => [],
  },
  selectedSubject: {
    type: Object,
    required: false,
    default: () => {},
  },
})

const activeClass = (subj) => ({
  'text-white': subj.id === props.selectedSubject.id,
  'bg-indigo-500': subj.id === props.selectedSubject.id,
})
</script>
